import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export const monthsNames = [
  "января",
  "февраля",
  "марта",
  "апреля",
  "мая",
  "июня",
  "июля",
  "августа",
  "сентября",
  "октября",
  "ноября",
  "декабря",
];

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const isIframe = window.self !== window.top;

export function declOfNum(number, titles, show_number = true) {
  if (!number) {
    number = 0;
  }
  const cases = [2, 0, 1, 1, 1, 2];
  const counter = show_number ? `${number.toLocaleString("ru")} ` : ``;
  return (
    counter +
    titles[
      number % 100 > 4 && number % 100 < 20
        ? 2
        : cases[number % 10 < 5 ? number % 10 : 5]
    ]
  );
}

export const checkAndFormatPhoneNumber = (phone = "", maxDigits = 10) => {
  // 1. Удалить ВСЕ нецифровые символы
  let digits = phone.replace(/\D/g, "");

  if (digits.length > maxDigits) {
    digits = digits.slice(-maxDigits);
  }

  // 2. Автоматически определяем, похоже ли на вставку номера с кодом страны
  // Признаки вставки:
  // - Содержит +7 или начинается с 7/8
  // - Цифр 11 или больше
  // - Или если после удаления нецифровых символов все равно много цифр
  const hasCountryCode =
    phone.includes("+7") ||
    (digits.length > 0 && (digits[0] === "7" || digits[0] === "8"));

  const isLikelyFullNumberPaste = digits.length >= 11 || hasCountryCode;

  // 3. Обрабатываем цифры
  let finalDigits = digits;

  if (isLikelyFullNumberPaste) {
    // Это вставка полного номера
    // Удаляем первую цифру если это 7 или 8
    if (
      finalDigits.length > 0 &&
      (finalDigits[0] === "7" || finalDigits[0] === "8")
    ) {
      finalDigits = finalDigits.slice(1);
    }

    // Берем только первые 10 цифр (не последние!)
    finalDigits = finalDigits.slice(0, maxDigits);
  } else {
    // Обычный ввод посимвольно
    // Удаляем первую цифру если это 7 или 8 (только для коротких номеров)
    if (
      finalDigits.length <= maxDigits &&
      finalDigits.length > 0 &&
      (finalDigits[0] === "7" || finalDigits[0] === "8")
    ) {
      finalDigits = finalDigits.slice(1);
    }

    // Берем только первые 10 цифр
    finalDigits = finalDigits.slice(0, maxDigits);
  }

  const isCompleted = finalDigits.length === maxDigits;

  // 4. Форматируем
  let formattedPhone = "";
  if (finalDigits.length === 0) {
    formattedPhone = "+7 (";
  } else if (finalDigits.length <= 3) {
    formattedPhone = `+7 (${finalDigits}`;
  } else if (finalDigits.length <= 6) {
    formattedPhone = `+7 (${finalDigits.slice(0, 3)}) ${finalDigits.slice(3)}`;
  } else if (finalDigits.length <= 8) {
    formattedPhone = `+7 (${finalDigits.slice(0, 3)}) ${finalDigits.slice(
      3,
      6,
    )} ${finalDigits.slice(6)}`;
  } else {
    formattedPhone = `+7 (${finalDigits.slice(0, 3)}) ${finalDigits.slice(
      3,
      6,
    )} ${finalDigits.slice(6, 8)} ${finalDigits.slice(8)}`;
  }

  return [formattedPhone, isCompleted];
};

export const getContrastColor = (hex) => {
  // Убираем # если есть
  let color = hex.replace("#", "");

  // Если короткая запись (3 символа), преобразуем в полную (6 символов)
  if (color.length === 3) {
    color = color
      .split("")
      .map((char) => char + char)
      .join("");
  }

  // Конвертируем hex в RGB
  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);

  // Вычисляем относительную яркость по формуле W3C
  // https://www.w3.org/TR/WCAG20/#relativeluminancedef
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Если яркость больше 0.5, возвращаем черный, иначе белый
  return luminance > 0.7 ? "#000000" : "#ffffff";
};

// доп форматирование значений с одним числом
export const decimalFormat = (date) =>
  date < 10 ? `0${date}` : date.toString();

export const getDateString = (dt = null) => {
  const date = dt ? new Date(dt) : new Date(Date.now());
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${year}-${decimalFormat(month)}-${decimalFormat(day)}`;
};
export const getDateFString = (date) => {
  const dt = date ? date : new Date(Date.now()); // ?
  const day = dt.getDate();
  const month = dt.getMonth() + 1;
  const year = dt.getFullYear();
  return `${year}-${decimalFormat(month)}-${decimalFormat(day)}`;
};
export function dateToMonth(dateStr, fullname = false) {
  const date = new Date(dateStr);
  const day = date.getDate();
  let month = monthsNames[date.getMonth()];
  if (!fullname) {
    month = month?.substring(0, 3);
  }
  return `${day} ${month}`;
}

export const dateMinusDays = (date, days = 1) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() - days);
  return getDateString(newDate);
};

export const datesDiff = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  const diffTime = Math.abs(d2 - d1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
};

export const datePlusDays = (date, days = 1) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return getDateString(newDate);
};

export const generateShortCode = (length) => {
  let result = "";
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const addZero = (value = 0) => {
  return value.toString().padStart(2, "0");
};

export function addMinutesToTime(hours, minutes, minutesToAdd) {
  // Конвертируем всё в минуты и складываем
  const totalMinutes = hours * 60 + minutes + minutesToAdd;

  // Вычисляем новые часы и минуты
  const newHours = Math.floor(totalMinutes / 60) % 24;
  const newMinutes = totalMinutes % 60;

  return { hours: newHours, minutes: newMinutes };
}
